import { FC } from "react";
import Lottie from "lottie-react";
import { Link } from "react-router-dom";
import { Button, Center, Stack } from "@chakra-ui/react";
import Layout from "components/Layout";
import notFoundAnimation from "assets/lottie/42479-page-not-found-404.json";

const NotFound: FC = () => {
  return (
    <Layout withSidebar={false}>
      <Center minH="100vh">
        <Stack w="60%" alignItems="center">
          <Lottie animationData={notFoundAnimation} />
          <Button
            as={Link}
            to="/"
            variant="outline"
            w="250px"
            colorScheme="black"
          >
            Back to Home
          </Button>
        </Stack>
      </Center>
    </Layout>
  );
};

export default NotFound;
